const message = {
	'label': {
		'attendanceMax': 'Max.',
		'attendanceAvg': 'Schnitt',
		'attendanceMin': 'Min.',
		'g': 'Tore',
		'a': 'Assists',
		'p': 'Punkte',
		'pim': 'Strafminuten',
		'plmi': 'Plus/Minus'
	},
	'leagueIdLong': {
		'all': 'Alle Ligen',
		'a': 'National League',
		'b': 'Swiss League',
		'c': 'Swiss Cup',
		'cup': 'Swiss Cup',
		'chl': 'Champions Hockey League'
	},
	'leagueIdShort': {
		'all': 'Alle',
		'a': 'NL',
		'b': 'SL',
		'c': 'Cup',
		'cup': 'Cup',
		'chl': 'CHL'
	},
	'gameTypeId': {
		'all': 'Alle',
		'm': 'Qualifikation',
		'p': 'Play-off',
		'l': 'Liga-Qualifikation',
		'r': 'Relegation'
	},
	'gameTypeIdShort': {
		'all': 'Alle',
		'm': 'Q',
		'p': 'P',
		'l': 'L',
		'r': 'R'
	},
	'homeAway': {
		'both': 'Alle',
		'a': 'Auswärts',
		'h': 'Heim'
	},
	'position': {
		'G': 'Torhüter',
		'S': 'Stürmer',
		'V': 'Verteidiger',
		'null': 'unbekannt'
	},
	'country': {
		'bel': 'Belgien',
		'bos': 'Bosnien-Herzegowina',
		'bul': 'Bulgarien',
		'can': 'Kanada',
		'cze': 'Tschechien',
		'dan': 'Dänemark',
		'deu': 'Deutschland',
		'est': 'Estland',
		'fin': 'Finnland',
		'fra': 'Frankreich',
		'gbr': 'Grossbritannien',
		'gri': 'Griechenland',
		'hol': 'Holland',
		'ira': 'Iran',
		'irl': 'Irland',
		'isl': 'Island',
		'isr': 'Israel',
		'ita': 'Italien',
		'jap': 'Japan',
		'jug': 'Jugoslawien',
		'kas': 'Kasachstan',
		'kro': 'Kroatien',
		'let': 'Lettland',
		'lib': 'Liberia',
		'lit': 'Litauen',
		'lux': 'Luxenbourg',
		'mex': 'Mexiko',
		'ned': 'Niederlande',
		'nor': 'Norwegen',
		'oes': 'Österreich',
		'pol': 'Polen',
		'por': 'Portugal',
		'rum': 'Rumänien',
		'rus': 'Russland',
		'slk': 'Slowakei',
		'sln': 'Slowenien',
		'spa': 'Spanien',
		'sui': 'Schweiz',
		'swe': 'Schweden',
		'tur': 'Türkei',
		'ukr': 'Ukraine',
		'ung': 'Ungarn',
		'usa': 'USA',
		'wru': 'Weissrussland',
		'null': ''
	},
	'grid': {
		'first': 'Erste',
		'last': 'Letzte',
		'loadingOoo': 'Lade Daten ...',
		'next': 'Nächste',
		'noRowsToShow': 'Keine Daten',
		'of': 'von',
		'page': 'Seite',
		'previous': 'Vorherige',
		'to': 'bis',
	},

};
export default message;
